<template>
  <div class="rounded bg-grey_3 pa-3 my-3 course_item bordered" :style="{ 'background-color': get_background(course) }">
    <div class="d-flex justify-space-between flex-wrap flex-md-nowrap gap">
      <div class="d-flex flex-column sm-gap content_course_item">
        <h3 class="font-weight-bold">
          {{ course.nom }}
          <span class="text-h6 font-weight-bold text-darkblue">
            <span class="text-primary-dark">| </span>

            <span v-if="course.metadatas.discipline != 'Non sportif' && course.date_depart != '0000-00-00'"> Départ
              :</span>
            <span v-if="course.metadatas.discipline != 'Non sportif' && course.date_depart != '0000-00-00'"
              class="text-darkblue" style="text-transform: capitalize">
              {{ $moment(course.date_depart).format("dddd DD MMMM") }}

            </span>
            <span v-if="course.heure_depart != '00:00:00'"> à {{
              course.heure_depart }}</span>
          </span>
        </h3>
        <CourseProperties :course="course"></CourseProperties>

        <!-- Indications supplémentaires -->
        <div v-if="course.metadatas.indications" class="font-italic" v-html="course.metadatas.indications"></div>
        <!-- Propriété de la course en liste d'icones -->
      </div>

      <div class="d-flex flex-column flex-start content_course_item">
        <!-- Bouton _s'inscrire_ de préselection -->

        <div v-if="show_inscription_button">
          <v-btn class="inscription_btn shadowed" color="dark-green" size="default" variant="tonal"
            @click="addToPreselection(course)">
            <v-icon icon="mdi-arrow-right-bold" class="mr-2"></v-icon>
            S'inscrire
          </v-btn>
          <!-- Section tarif de la course -->
          <TarifsCourse :tarifs="course.tarifs" :course="course"></TarifsCourse>
        </div>

        <!-- Bouton disabled si les inscriptions sont closes -->
        <div v-else>
          <v-btn v-if="mainStore.module.status == 'avant_ouverture'" class="shadowed" color="dark-red" size="small"
            variant="tonal"><v-icon icon="mdi-pencil-off-outline"></v-icon> Ouverture à venir</v-btn>
          <v-btn v-else-if="course.is_complet(all_courses)" class="shadowed" color="dark-red" size="small"
            variant="tonal"><v-icon icon="mdi-pencil-off-outline"></v-icon> course complète</v-btn>
          <v-btn v-else-if="mainStore.module.is_complet" class="shadowed" color="dark-red" size="small"
            variant="tonal"><v-icon icon="mdi-pencil-off-outline"></v-icon> course complète</v-btn>
          <v-btn v-else class="shadowed" color="dark-red" size="small" variant="tonal"><v-icon
              icon="mdi-pencil-off-outline"></v-icon> Inscriptions closes</v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import CourseProperties from "@/components/Home/Courses/Course_Properties.vue";
import TarifsCourse from "@/components/Home/Courses/Tarifs_Course.vue";
export default {
  props: ["course"],
  components: { CourseProperties, TarifsCourse },
  computed: {
    ...mapStores(useMainStore),
    show_inscription_button() {
      const course_selectionable = this.course.is_selectionnable(
        this.mainStore.module.status,
        this.mainStore.view_as_admin,
        this.mainStore.inscription_as_admin,
        this.mainStore.inscription_vip,
        this.mainStore.module.courses,
        this.mainStore.module.is_complet
      );
      
      return course_selectionable;
    },
    all_courses() {
      return this.mainStore.module.courses;
    },
  },
  methods: {
    get_background(course) {
      if (course.metadatas.couleur_fond) {
        return course.metadatas.couleur_fond + " !important";
      } else {
        return "";
      }
    },
    /* Si clic sur button _s'inscrire_ on ajoute en mémoire la préselection pour l'ajouter à la sélection de parcours du premier coureur en page suivante */
    async addToPreselection(course) {
      this.mainStore.bookingSystem.preselection = { type: "course", value: course.id, course: course };
      this.mainStore.bookingSystem.is_inscription_groupe = false;
      this.$router.push({ name: "Inscriptions" });
    },
  },
};
</script>

<style lang="scss" scoped></style>